import { render } from "./BillsComponent.vue?vue&type=template&id=f8da250a&scoped=true"
import script from "./BillsComponent.vue?vue&type=script&lang=js"
export * from "./BillsComponent.vue?vue&type=script&lang=js"

import "./BillsComponent.vue?vue&type=style&index=0&id=f8da250a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8da250a"]])

export default __exports__